import { cloneDeep, upperCase } from "lodash-es";
import React, { useEffect, useState } from "react";

import { ButtonGroup } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { capitalize } from "@mui/material/utils";

import { CirclePlus, DeleteIcon } from "../../../components/icons";
import { PplRule } from "../../../store/pomeriumApi";
import { ALL_LOGICAL_OPERATORS } from "../../../utils/ppl";
import PPLBlock from "./PPLBlock";

interface AllowDenyBlockProps {
  readonly: boolean;
  pplArr: any[];
  savePPL(ppl: PplRule[]): void;
  blockIDX: number;
  allowDeny: "allow" | "deny";
  currentConditions: string[];
}

const AllowDenyBlock = (
  props: React.PropsWithChildren<AllowDenyBlockProps>,
) => {
  const { readonly, pplArr, savePPL, blockIDX, allowDeny, currentConditions } =
    props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [conditionsLeft, setConditionsLeft] = useState(
    ALL_LOGICAL_OPERATORS.filter((e) => !currentConditions.includes(e)),
  );

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: any) => {
    setAnchorEl(event?.currentTarget);
  };

  const addCondition = (condition: "and" | "or" | "not" | "nor") => {
    const arr = cloneDeep(pplArr);

    setConditionsLeft(conditionsLeft.filter((e) => e != condition));
    setAnchorEl(null);
    arr[blockIDX][allowDeny][condition] = [
      {
        domain: { is: "pomerium.com" },
      },
    ];
    savePPL(arr);
  };

  useEffect(() => {
    setConditionsLeft(
      ALL_LOGICAL_OPERATORS.filter((e) => !currentConditions.includes(e)),
    );
  }, [currentConditions]);

  return (
    <PPLBlock
      title={upperCase(allowDeny)}
      actions={
        <>
          <Menu
            id="addConditionAccordionMenu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            {conditionsLeft.map((condition) => {
              return (
                <MenuItem
                  key={blockIDX + "condition" + condition}
                  onClick={() => addCondition(condition)}
                >
                  {capitalize(condition)}
                </MenuItem>
              );
            })}
          </Menu>
          <ButtonGroup>
            <IconButton
              color={"default"}
              onClick={() => {
                const arr = cloneDeep(pplArr);
                arr.splice(blockIDX, 1);
                savePPL(arr);
              }}
              disabled={readonly}
              sx={{ p: 0 }}
            >
              <DeleteIcon fontSize="medium" />
            </IconButton>
            <IconButton
              onClick={handleClick}
              disabled={readonly}
              sx={{ p: 0, ml: 0.5 }}
            >
              <CirclePlus fontSize="medium" />
            </IconButton>
          </ButtonGroup>
        </>
      }
    >
      {props.children}
    </PPLBlock>
  );
};

export default AllowDenyBlock;
